function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "address");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("filter", {
  x: "-4.7%",
  y: "-6.1%",
  width: "109.4%",
  height: "112.1%",
  filterUnits: "objectBoundingBox",
  id: "filter-1"
}, React.createElement("feOffset", {
  dx: 0,
  dy: 0,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 2,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
  type: "matrix",
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1"
}), React.createElement("feMerge", null, React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), React.createElement("feMergeNode", {
  in: "SourceGraphic"
}))), React.createElement("linearGradient", {
  x1: "49.9999673%",
  y1: "100.000021%",
  x2: "49.9999673%",
  y2: "-1.92781947e-05%",
  id: "linearGradient-2"
}, React.createElement("stop", {
  stopColor: "#808080",
  stopOpacity: 0.25,
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#808080",
  stopOpacity: 0.12,
  offset: "53.514%"
}), React.createElement("stop", {
  stopColor: "#808080",
  stopOpacity: 0.1,
  offset: "100%"
})), React.createElement("polygon", {
  id: "path-3",
  points: "131.749213 116.229477 99.3509843 116.229477 49.9301181 120.965847 0.126771654 116.229477 0.126771654 0.187354839 49.723622 3.73968065 100.391535 0.187354839 149.957874 6.89719516 149.957874 98.0734274"
}), React.createElement("linearGradient", {
  x1: "50.0002995%",
  y1: "99.9999593%",
  x2: "50.0002995%",
  y2: "0.000195543244%",
  id: "linearGradient-5"
}, React.createElement("stop", {
  stopColor: "#000000",
  stopOpacity: 0.12,
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#000000",
  stopOpacity: 0.09,
  offset: "55.135%"
}), React.createElement("stop", {
  stopColor: "#000000",
  stopOpacity: 0.02,
  offset: "100%"
})));

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  opacity: 0.686081659
}, React.createElement("g", {
  id: "Profile---Manage-Address---Landing",
  transform: "translate(-840.000000, -416.000000)"
}, React.createElement("g", {
  id: "Right-Pane",
  transform: "translate(474.000000, 195.000000)"
}, React.createElement("g", {
  id: "Right-Pane-Content",
  transform: "translate(18.000000, 26.000000)"
}, React.createElement("g", {
  id: "No-Address-graphic",
  transform: "translate(289.000000, 199.000000)"
}, React.createElement("g", {
  id: "address",
  filter: "url(#filter-1)",
  transform: "translate(63.000000, 0.000000)"
}, React.createElement("polygon", {
  id: "Path",
  fill: "url(#linearGradient-2)",
  fillRule: "nonzero",
  points: "139.510811 126.823645 107.94512 126.823645 54.1806073 132 0 126.823645 0 0 53.9559636 3.88226658 109.077229 0 163 7.33330071 161.615784 104.725477"
}), React.createElement("polygon", {
  id: "Path",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  points: "139.087269 124.980369 108.296181 124.980369 55.8510395 130 3 124.980369 3 2 55.6319335 5.76462555 109.400381 2 162 9.11117614 160.6497 103.552028"
}), React.createElement("polygon", {
  id: "Path",
  fill: "#7AC7B8",
  fillRule: "nonzero",
  points: "138.770616 122.254756 106.336063 122.254756 56.8594875 127 7 122.254756 7 6 56.6527586 9.55883503 107.377788 6 157 12.7223308 157 104.065437"
}), React.createElement("g", {
  id: "Clipped",
  transform: "translate(20.000000, 7.000000)"
}, React.createElement("mask", {
  id: "mask-4",
  fill: "white"
}, React.createElement("use", {
  xlinkHref: "#path-3"
})), React.createElement("g", {
  id: "Path"
}), React.createElement("polygon", {
  id: "Path",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  mask: "url(#mask-4)",
  points: "181.505118 149.521456 67.7340551 87.0581339 96.6320866 -8.13198065 86.7974409 -11.9985161 72.7929134 34.1323435 -38.7860236 -27.1274194 -43.3070866 -16.4626355 69.3718504 45.4011516 43.6468504 130.139013 53.4814961 134.005548 64.3129921 98.3267468 176.984055 160.18624"
})), React.createElement("polygon", {
  id: "Path",
  fill: "url(#linearGradient-5)",
  fillRule: "nonzero",
  points: "137 125 137.370431 101 160 101.932937"
}), React.createElement("polygon", {
  id: "Path",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  points: "7 55 78.2640466 86.3611424 83 96.1184933 78.2850673 101 7 67.3982461"
}), React.createElement("polygon", {
  id: "Path",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  points: "138 125 138.354226 103 160 103.855089"
}), React.createElement("polygon", {
  id: "Path",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  points: "105 105.930466 134.331837 9 146 10.6029477 113.139227 111"
}), React.createElement("polyline", {
  id: "Path",
  fill: "#000000",
  fillRule: "nonzero",
  opacity: 0.1,
  points: "57 127 106 122.254756 106 6 57 9.55883503"
}), React.createElement("path", {
  d: "M101.999999,48.0113795 C101.999999,57.4033191 84.999999,84 84.999999,84 C84.999999,84 68.000001,57.4033191 68.000001,48.0113795 C67.997941,41.934486 71.2376719,36.3183231 76.4983359,33.2792813 C81.759,30.2402396 88.241,30.2402396 93.5016641,33.2792813 C98.7623281,36.3183231 102.002059,41.934486 101.999999,48.0113795 Z",
  id: "Path",
  fill: "#FF5252",
  fillRule: "nonzero"
}), React.createElement("ellipse", {
  id: "Oval",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  cx: 84.5,
  cy: 47,
  rx: 5.5,
  ry: 5
}), React.createElement("polygon", {
  id: "Path",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  points: "130.860074 56 157 62.6279432 157 75 125 63.712661"
}), React.createElement("polygon", {
  id: "Path",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  points: "30.463973 79.8669508 24 125.42623 31.3359906 127 41 84.9586885 40.9886099 79"
}), React.createElement("polygon", {
  id: "Path",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  points: "30.6333086 21.0129122 23 62.9733405 28.9103792 66 43 21"
}), React.createElement("ellipse", {
  id: "Oval",
  fill: "#FF5252",
  fillRule: "nonzero",
  cx: 45,
  cy: 12.5,
  rx: 2,
  ry: 1.5
}), React.createElement("ellipse", {
  id: "Oval",
  fill: "#FF5252",
  fillRule: "nonzero",
  cx: 26,
  cy: 92.5,
  rx: 2,
  ry: 1.5
}), React.createElement("ellipse", {
  id: "Oval",
  fill: "#FF5252",
  fillRule: "nonzero",
  cx: 24,
  cy: 104.5,
  rx: 2,
  ry: 1.5
}), React.createElement("ellipse", {
  id: "Oval",
  fill: "#FF5252",
  fillRule: "nonzero",
  cx: 41,
  cy: 101.5,
  rx: 2,
  ry: 1.5
}), React.createElement("ellipse", {
  id: "Oval",
  fill: "#FF5252",
  fillRule: "nonzero",
  cx: 14,
  cy: 54.5,
  rx: 2,
  ry: 1.5
}), React.createElement("ellipse", {
  id: "Oval",
  fill: "#FF5252",
  fillRule: "nonzero",
  cx: 139,
  cy: 52.5,
  rx: 2,
  ry: 1.5
}), React.createElement("ellipse", {
  id: "Oval",
  fill: "#FF5252",
  fillRule: "nonzero",
  cx: 125,
  cy: 107.5,
  rx: 2,
  ry: 1.5
})))))));

var SvgNoAddress = function SvgNoAddress(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "171px",
    height: "140px",
    viewBox: "0 0 171 140",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgNoAddress, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/noAddress.fc4dd67c.svg";
export { ForwardRef as ReactComponent };